import { createSelector } from '@reduxjs/toolkit';
import { selectorSelectedDevice } from 'entities/device/lib';
export const select_blockly_backpack_contents = createSelector(selectorSelectedDevice, (device) => device?.blockly_contents ?? null);
